import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  WEBSITE_NAME,
} from "../modals/Constants";
import { setSessionStorage, getSessionStorage } from "../modals/Session";
import general from "../css/General.module.css";

function SplashScreen() {
  const navigate = useNavigate();
  const [countDown, setCountDown] = useState(2);

  const redirectToApp = () => {
    navigate("/home", { replace: true });
  };

  useEffect(() => {
    if (getSessionStorage("isPageLoaded") >= 1) {
      redirectToApp();
    } else {
      const timer = setInterval(() => {
        if (countDown > 1) {
          setCountDown(countDown - 1);
        } else {
          clearInterval(timer);
          setSessionStorage("isPageLoaded", 1)
          redirectToApp();
        }
      }, 1000);

      return () => {
        clearInterval(timer);
      };
    }
  }, [countDown]);

  return (
    <div
      className={[
        general.appContents,
        general.jusifyCenter
      ].join(" ")}
    >
      <h3 className="ft-sz-3em cl-white">{WEBSITE_NAME}</h3>
      <p className="ft-sz-18 cl-white">Withdraw fast, safe and secure</p>
    </div>
  );
}

export default SplashScreen;
